import { Stack, FormControlLabel, Checkbox, Skeleton } from '@mui/material'
import { ES_submitHasQualification } from '../../../firebase/teacherApi'
import { EmploymentSetting } from '../../../firebase/types-teacher'
import pxToRem from '../../../helpers/pxToRem'
import { DashboardTabNames } from '../../../routers/type'
import { useSelector } from 'react-redux'
import styles from '../index.module.scss'
import { selectUserUid } from '../../../redux/userSlice'
import { selectTeacherAccountState } from '../../../redux/teacherSlice'

const ESQualificationSelector = ({
    settingId,
    employmentSetting,
}: {
    settingId: string
    employmentSetting: EmploymentSetting
}) => {
    const userId = useSelector(selectUserUid)
    const accountState = useSelector(selectTeacherAccountState)

    if (employmentSetting.type !== 'supportStaff') return null
    if (!userId || accountState.status !== 'success') return <Skeleton />

    return (
        <Stack
            direction={'row'}
            gap={pxToRem(8)}
            alignItems={'center'}
            sx={{
                '>div': {
                    flexDirection: 'row',
                    alignItems: 'center',
                },
            }}
        >
            <FormControlLabel
                checked={employmentSetting.hasQualification === true}
                sx={{
                    color: styles.shades100,
                }}
                disabled={
                    location.pathname.includes(DashboardTabNames.REVIEW) ||
                    (accountState.data === 'submitted' &&
                        employmentSetting?.state !== 'rejected') ||
                    (['approved', 'onHold'].includes(accountState.data) &&
                        employmentSetting.state === 'submitted')
                }
                onChange={() =>
                    ES_submitHasQualification(userId, settingId, true)
                }
                control={
                    <Checkbox
                        icon={
                            // prettier-ignore
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_5685)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#A3A3A3" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_5685"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                        }
                        checkedIcon={
                            // prettier-ignore
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_7000)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="#60C1A3" />{' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#60C1A3" />{' '} <path d="M18.6663 7L9.49967 16.1667L5.33301 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_7000"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                        }
                    />
                }
                label="Yes"
            />
            <FormControlLabel
                checked={employmentSetting.hasQualification === false}
                sx={{
                    color: styles.shades100,
                }}
                disabled={
                    location.pathname.includes(DashboardTabNames.REVIEW) ||
                    (accountState.data === 'submitted' &&
                        employmentSetting.state !== 'rejected') ||
                    (['approved', 'onHold'].includes(accountState.data) &&
                        employmentSetting.state === 'submitted')
                }
                onChange={() =>
                    ES_submitHasQualification(userId, settingId, false)
                }
                control={
                    <Checkbox
                        icon={
                            // prettier-ignore
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_5685)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#A3A3A3" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_5685"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                        }
                        checkedIcon={
                            // prettier-ignore
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > {' '} <g clipPath="url(#clip0_660_7000)"> {' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="#60C1A3" />{' '} <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#60C1A3" />{' '} <path d="M18.6663 7L9.49967 16.1667L5.33301 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />{' '} </g>{' '} <defs> {' '} <clipPath id="clip0_660_7000"> {' '} <rect width="24" height="24" fill="white" />{' '} </clipPath>{' '} </defs>{' '} </svg>
                        }
                    />
                }
                label="No"
            />
        </Stack>
    )
}

export default ESQualificationSelector
